import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 border-t border-gray-200 py-6 px-4">
      <div className="max-w-4xl mx-auto text-center">
        
        {/* Disclaimer Section - Tighter spacing */}
        <div className="mb-4">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">
            Disclaimer
          </p>
          <p className="text-gray-500 text-xs leading-relaxed italic px-2">
            Information provided in the website is only for the family members. 
            The members communication would be privately by e-mails. 
            Users can reach out to the owners for clarifications.
          </p>
        </div>

        {/* Copyright Line - Smaller text and thinner border */}
        <div className="border-t border-gray-200 pt-4">
          <p className="text-[9px] font-bold text-gray-400 uppercase tracking-[0.2em]">
            &copy; {currentYear} MBA Trust. All Rights Reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;